export default "__VITE_ASSET__CBGUinia__"